<input
  tabindex="0"
  type="checkbox"
  id="checkbox_{{ productId }}"
  [formControl]="checkboxControl"
  [ngModel]="isChecked"
  (change)="onCheckboxChange(productId, $event.currentTarget.checked)"
/>
<label class="Body-Small-Book" for="checkbox_{{ productId }}">
  <div class="sr-only" [innerHTML]="alt + ' toggle'"></div>
  <i class="far fa-fw fa-check check"></i>
</label>
